import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { eAuth0ClientType } from 'ui-toolkit/authentication/types/eAuth0ClientType';
import { LoginPageLoading } from '../../components/loginPage/LoginPageLoading';
import { userTypeCookieName } from 'ui-toolkit/authentication/data/userTypeCookieName';
import Cookies from 'js-cookie';
import { getAuth0ClientTypeFromUserType } from 'ui-toolkit/authentication/methods/getAuth0ClientTypeFromUserType';
import { createAuth0ClientForSpruce } from '../../ui-toolkit/authentication/methods/createAuth0ClientForSpruce';
import { RootStore } from 'store/types';
import { useGetConfigQuery } from 'API/applicationConfig/ApplicationConfigAPI';
import { eAccessControlUserUrlTypes, mapUrlUserTypeToEnum } from '../../ui-toolkit/enums/eAccessControlUserType';

export const Auth0LoginContainer: React.FC = () => {
  const { userType: rawUserType } = useParams<{ userType: eAccessControlUserUrlTypes }>();
  const userType = mapUrlUserTypeToEnum[rawUserType];
  const [authClientType, setAuthClientType] = React.useState<eAuth0ClientType>();
  const { data: applicationConfig } = useGetConfigQuery();
  const redirectTargetValue = useSelector((root: RootStore) => root.redirectTargetSlice.target);

  useEffect(() => {
    const clientType = getAuth0ClientTypeFromUserType(userType);
    setAuthClientType(clientType);
    Cookies.set(userTypeCookieName, userType, {
      secure: true,
      sameSite: 'strict',
    });
  }, [userType]);

  useEffect(() => {
    const validExecutionCondition = authClientType && applicationConfig && userType;
    if (validExecutionCondition) {
      const clientConfig = applicationConfig.loginConfigurations[authClientType];
      createAuth0ClientForSpruce(clientConfig, userType).then(async (auth0Client) => {
        await auth0Client.loginWithRedirect({
          redirect_uri: `${window.location.origin}/spa/logged_in${
            redirectTargetValue ? `?redirect_to=${encodeURIComponent(redirectTargetValue)}` : ``
          }`,
        });
      });
    }
  }, [authClientType, applicationConfig, userType, redirectTargetValue]);

  return <LoginPageLoading />;
};
